import { FilterOption } from "@models/grid/grid-filter";

export enum WarningState {
  Dob,
  Address,
  MiddleName,
  FullName,
  DIN
}

export enum IndividualVerificationProvider {
  Annature
}

export const warningStateLabels: Record<WarningState, string> = {
  [WarningState.Dob]: 'Date of Birth',
  [WarningState.Address]: 'Address',
  [WarningState.MiddleName]: 'Middle Name',
  [WarningState.FullName]: 'Full Name',
  [WarningState.DIN]: 'Director ID',
};

const warningStatesList = [
  WarningState.Address,
  WarningState.DIN,
  WarningState.Dob,
  WarningState.FullName,
  WarningState.MiddleName,
];

export const warningStateFilterOptions: FilterOption[] = warningStatesList
  .map((warningState) => {
    return {
      label: warningStateLabels[warningState],
      value: WarningState[warningState],
      active: false
    };
  });

export const warningStatesFilterValues = warningStatesList.map((warningState) => WarningState[warningState]);
